<template>
    <div id="company-show-content">
        <Breadcrumbs
            :breadcrumbs="breadcrumbs"
            class="container pt-2 mb-3 md:pt-5"
        ></Breadcrumbs>

        <CompanyShowHeader id="company-show-header" />

        <div class="md:container flex">
            <div class="min-w-0 w-full">
                <div class="company-content overflow-y-visible">
                    <div
                        v-if="showIntroSection"
                        class="pt-6 md:pt-10 lg:pt-16 md:mb-4 lg:mb-9 lg:text-lg max-md:container text-slate-600"
                    >
                        <!-- eslint-disable -->
                        <div
                            v-tracking="{
                                name: 'text intro',
                                value: currentCompany.content.text_intro,
                            }"
                        ></div>
                        <!-- eslint-enable -->
                    </div>
                    <div
                        v-if="showAboutUsSection"
                        id="about"
                        class="section pt-6 md:mb-4 lg:mb-9 max-md:container"
                    >
                        <CollapsibleItem
                            :opened="sectionCollapsible.about"
                            :header="t('show.section_about_us')"
                            appearance="section"
                            btn-classes="px-0"
                            header-style="text-3xl md:text-5xl lg:text-6xl font-medium"
                            icon-size="xl"
                            content-classes="pt-4 md:pt-8 lg:text-lg"
                            data-click="collapsible,about"
                            @toggled="sectionCollapsible.about = !sectionCollapsible.about"
                        >
                            <template #body>
                                <!-- eslint-disable -->
                                <div
                                    class="text-slate-600"
                                    v-tracking="{
                                        name: 'about us',
                                        value: currentCompany.content.text_about_us,
                                    }"
                                ></div>
                                <!-- eslint-enable -->
                            </template>
                        </CollapsibleItem>
                    </div>
                    <div
                        v-if="showCareerSection"
                        id="career"
                        class="section pt-6 md:mb-4 lg:mb-9 max-md:container"
                    >
                        <CollapsibleItem
                            :opened="sectionCollapsible.career"
                            :header="t('show.section_career')"
                            appearance="section"
                            btn-classes="px-0"
                            header-style="text-3xl md:text-5xl lg:text-6xl font-medium"
                            icon-size="xl"
                            content-classes="pt-4 md:pt-8 lg:text-lg"
                            data-click="collapsible,career"
                            @toggled="sectionCollapsible.career = !sectionCollapsible.career"
                        >
                            <template #body>
                                <!-- eslint-disable -->
                                <div
                                    class="text-slate-600"
                                    v-tracking="{
                                        name: 'career',
                                        value: currentCompany.content.text_career,
                                    }"
                                ></div>
                                <!-- eslint-enable -->
                                <div
                                    v-if="currentCompany.links && currentCompany.links.length > 0"
                                    class="links-container mt-4"
                                >
                                    <Btn
                                        v-for="link in currentCompany.links"
                                        :key="link._id"
                                        :target="link.new_tab ? '_blank' : '_SELF'"
                                        :href="link.url"
                                        :data-click="`career link,${link.url}`"
                                        right-icon="icon icon-arrow-circled-right"
                                        variant="tonal"
                                        color="primary"
                                        elevated
                                        class="btn-link"
                                        content-spacing="apart"
                                    >
                                        <div class="flex flex-col">
                                            <span
                                                class="text-left text-blue-600"
                                                v-text="link.headline"
                                            ></span>
                                            <span
                                                class="font-normal truncate mt-1 text-slate-600"
                                                v-text="link.subheadline"
                                            ></span>
                                        </div>
                                    </Btn>
                                </div>
                            </template>
                        </CollapsibleItem>
                    </div>
                    <CompanyShowJobWidget
                        v-if="companyJobs?.length"
                        :company-id="company.id"
                        class="mt-6"
                    ></CompanyShowJobWidget>

                    <div
                        v-if="showArticlesSection"
                        id="articles"
                        class="section pt-6 md:mb-4 lg:mb-9"
                    >
                        <CollapsibleItem
                            :opened="sectionCollapsible.articles"
                            :header="t('show.section_articles')"
                            appearance="section"
                            btn-classes="px-4 md:px-0"
                            header-style="text-3xl md:text-5xl lg:text-6xl font-medium"
                            content-classes="pt-4 md:pt-8 lg:text-lg"
                            icon-size="xl"
                            data-click="collapsible,news & events"
                            @toggled="sectionCollapsible.articles = !sectionCollapsible.articles"
                        >
                            <template #body>
                                <!-- eslint-disable -->
                                <div
                                    class="max-md:container text-slate-600"
                                    v-tracking="{
                                        name: 'news & events',
                                        value: currentCompany.content.text_articles,
                                    }"
                                ></div>
                                <!-- eslint-enable -->
                                <CompanyShowArticlesCarousel
                                    v-if="currentCompany.articles && currentCompany.articles.length > 0"
                                    :articles="currentCompany.articles"
                                    class="px-0 shadow"
                                />
                            </template>
                        </CollapsibleItem>
                    </div>
                    <div
                        v-if="showVideosSection"
                        id="videos"
                        class="section pt-6 md:mb-4 lg:mb-9"
                    >
                        <CollapsibleItem
                            :opened="sectionCollapsible.videos"
                            :header="t('show.section_videos')"
                            appearance="section"
                            btn-classes="px-4 md:px-0"
                            header-style="text-3xl md:text-5xl lg:text-6xl font-medium "
                            icon-size="xl"
                            content-classes="pt-4 md:pt-8 lg:text-lg"
                            data-click="collapsible,videos"
                            @toggled="sectionCollapsible.videos = !sectionCollapsible.videos"
                        >
                            <template #body>
                                <div>
                                    <!-- eslint-disable -->
                                    <div
                                        class="max-md:container text-slate-600"
                                        v-tracking="{
                                            name: 'videos',
                                            value: currentCompany.content.text_videos,
                                        }"
                                    ></div>
                                    <!-- eslint-enable -->
                                    <CompanyShowVideoCarousel
                                        v-if="currentCompany.videos && currentCompany.videos.length > 0"
                                        :videos="currentCompany.videos"
                                        class="px-0 shadow"
                                    />
                                </div>
                            </template>
                        </CollapsibleItem>
                    </div>
                </div>
                <div class="max-md:container lg:hidden">
                    <CompanyShowDetails
                        v-if="currentCompany"
                        :is-facebook-plugin-enabled="isFacebookEnabled"
                        class="pt-6 flex masonry"
                    ></CompanyShowDetails>
                </div>
            </div>
            <TheRightSidebar top-spacing>
                <CompanyShowDetails
                    v-if="currentCompany"
                    :is-facebook-plugin-enabled="isFacebookEnabled"
                    class="hidden lg:flex lg:px-0"
                ></CompanyShowDetails>
            </TheRightSidebar>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from '@components/Breadcrumbs';
import CollapsibleItem from '@components/CollapsibleItem';
import { mapGetters } from 'vuex';
import TheRightSidebar from '@components/TheRightSidebar';
import { isServiceAllowed } from '@/utils/usercentricsUtils';
import { initializeClickListeningToTrack, trackImpression } from '@/modules/tracking';
import route from '@router/route';
import { useTranslation } from 'i18next-vue';
import CompanyShowJobWidget from './CompanyShowJobWidget.vue';
import CompanyShowDetails from './CompanyShowDetails.vue';
import CompanyShowHeader from './CompanyShowHeader.vue';
import CompanyShowVideoCarousel from './CompanyShowVideoCarousel.vue';
import CompanyShowArticlesCarousel from './CompanyShowArticlesCarousel.vue';

export default {
    name: 'CompanyShow',
    components: {
        CompanyShowJobWidget,
        CompanyShowArticlesCarousel,
        CollapsibleItem,
        Breadcrumbs,
        CompanyShowHeader,
        CompanyShowDetails,
        CompanyShowVideoCarousel,
        TheRightSidebar,
    },
    setup() {
        const { t } = useTranslation('company');
        return { t };
    },
    data() {
        return {
            company: window.sdWindow.company,
            sectionCollapsible: {
                about: true,
                career: true,
                articles: true,
                videos: true,
            },
            isFacebookEnabled: false,
            accessDate: Date.now(),
            actionImpression: 1,
            actionClick: 2,
            removeClickListener: null,
        };
    },
    computed: {
        breadcrumbs() {
            return [
                {
                    title: this.t('breadcrumbs.companyIndex'),
                    link: route('company.index'),
                },
                {
                    title: this.currentCompany.name,
                    link: route('company.show', {
                        companySlug: this.company.slug,
                    }),
                },
            ];
        },
        ...mapGetters({
            currentCompany: 'company/currentCompany',
            showIntroSection: 'company/showIntroSection',
            showAboutUsSection: 'company/showAboutUsSection',
            showCareerSection: 'company/showCareerSection',
            showArticlesSection: 'company/showArticlesSection',
            showVideosSection: 'company/showVideosSection',
            locale: 'ui/getLocale',
            companyJobs: 'careerCorner/companyJobs',
        }),
    },
    watch: {
        isFacebookEnabled(val) {
            if (!val) return;
            this.$store.dispatch('auth/initializeFacebookAuthentication', { statusCheck: false });
        },
    },
    mounted() {
        this.$store.dispatch('company/setCompanyData', this.company);
        this.$store.dispatch('company/retrieveProfile', this.company.id);
        this.$store.dispatch('company/retrieveArticles', this.company.id);
        this.$store.dispatch('careerCorner/getCompanyJobsById', this.company.id);

        const trackingData = {
            company_id: this.company.id,
        };

        this.removeClickListener = initializeClickListeningToTrack(this.$el, 'CompanyPage', trackingData, true, true);
        trackImpression('CompanyPage', trackingData);

        this.checkFacebookService();
    },
    beforeUnmount() {
        this.removeClickListener();
    },
    methods: {
        async checkFacebookService() {
            this.isFacebookEnabled = await isServiceAllowed('Facebook Social Plugins');
        },
    },
};
</script>
<style lang="scss" scoped>
.company-content {
    @apply text-left text-base;
    @screen lg {
        @apply text-lg;
    }
    iframe {
        border-radius: 8px;
        min-height: 415px;
        margin: 0 auto;
        width: 100%;
        @screen lg {
            width: 80%;
        }
    }
    :deep(a:not(.btn-link)) {
        @apply text-blue-600;
    }
    .btn-link {
        @apply text-base w-full no-underline;
        &:active,
        &:hover {
            @apply no-underline;
        }
        &:not(:last-child) {
            @apply mb-4;
        }
    }

    ol {
        @apply pl-5 py-5 list-decimal;
    }

    ul {
        @apply pl-5 py-5 list-disc;
    }
    .fixed-link-icon-width {
        width: 36px;
        flex: 0 0 36px;
    }
    :deep(.agile__slides) {
        @apply items-start self-stretch;
    }
}
</style>
